// Soft-confirm limit for a typed application amount (a likely typo such as 9,999,999 kg):
// more than 3x the largest earlier amount of that product on the crop, or with no history
// more than 1,000 kg or L, 1,000,000 g or mL, 100,000 pcs.
const NO_HISTORY_LIMIT: Record<string, number> = { kg: 1000, L: 1000, g: 1_000_000, mL: 1_000_000, pcs: 100_000 };

export function bigAmountLimit(priorMax: number, unit: string): number {
  return priorMax > 0 ? priorMax * 3 : (NO_HISTORY_LIMIT[unit] ?? Infinity);
}

// applications.amount is DECIMAL(10,3): anything longer is a 500 that no retry fixes.
const MAX_INT_DIGITS = 7;
const MAX_DECIMALS = 3;
export const PRECISION_HINT = `Up to ${MAX_INT_DIGITS} digits before the point and ${MAX_DECIMALS} after`;

export function fitsPrecision(text: string): boolean {
  const [whole, frac = ''] = text.split('.');
  return whole.length <= MAX_INT_DIGITS && frac.length <= MAX_DECIMALS;
}
